module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nt-toasts",
    attrs: {
      "aria-live": "polite"
    }
  }, _vm._l((_vm.toasts), function(toast) {
    return _c('div', {
      key: toast.key,
      staticClass: "nt-toast",
      class: ("nt-toast-" + (toast.severity || 'info')),
      attrs: {
        "role": "status"
      }
    }, [_c('i', {
      staticClass: "fa nt-toast-icon",
      class: [_vm.icon(toast), ("nt-sev-" + (toast.severity))],
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "nt-toast-body",
      on: {
        "click": function($event) {
          return _vm.openItem(toast)
        }
      }
    }, [_c('strong', {
      staticClass: "nt-toast-title"
    }, [_vm._v(_vm._s(toast.title))]), _vm._v(" "), (toast.body) ? _c('span', {
      staticClass: "nt-toast-text"
    }, [_vm._v(_vm._s(toast.body))]) : _vm._e()]), _vm._v(" "), _c('button', {
      staticClass: "nt-toast-close",
      attrs: {
        "type": "button",
        "aria-label": "Dismiss"
      },
      on: {
        "click": function($event) {
          return _vm.dismiss(toast.key)
        }
      }
    }, [_vm._v("×")])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-f1b50cd4","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/notifications/NotificationToasts.vue
// module id = 652b
// module chunks = 1